import { dateUtils, getDeliveryByEventName } from '@noths/polaris-client-utils';
import { DeliveryByEventDisplayName } from '@noths/polaris-dev-ts-types';
import * as R from 'ramda';

import { DeliveryOptionInfo } from 'src/types';
import { copy } from './constants';

type DeliveryOption = Pick<DeliveryOptionInfo, 'exactDate' | 'date' | 'min' | 'max'>;

export const getReplacedPlaceholder = (label: string) => (event: DeliveryByEventDisplayName) => {
  if (!event) {
    // Prevent error if inadvertently called with no event label - this guard is better handled at the caller
    return '';
  }

  if (label.includes('{PREFIX}')) {
    return label.replace('{PREFIX}', event.prefix).replace('{EVENT}', event.name);
  }

  return label.replace('{EVENT}', event.name);
};

export const hasExactDeliveryDate = ({ exactDate, date }: DeliveryOption) =>
  exactDate && date != null;

export const isLateDelivery = (date: Date | string, constrainingDate: Date | string) =>
  dateUtils.isAfter(date, constrainingDate);

export const getMinDeliveryDate = (min: number) => dateUtils.getWithAddedDays(new Date(), min);

export const getMaxDeliveryDate = (max: number) => dateUtils.getWithAddedDays(new Date(), max);

export const isLateForEvent = (option: DeliveryOption, lastDeliveryBy: string | Date) => {
  if (hasExactDeliveryDate(option) && isLateDelivery(option.date!, lastDeliveryBy)) {
    return true;
  }

  const maxDeliveryDate = getMaxDeliveryDate(option.max!);
  const isMaxDeliveryDateLate = maxDeliveryDate && isLateDelivery(maxDeliveryDate, lastDeliveryBy);

  return isMaxDeliveryDateLate;
};

export const getDeliveryByEventLabel = R.compose(
  getReplacedPlaceholder(copy.DELIVERY_EVENT_LABEL),
  getDeliveryByEventName,
);
